import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import AllPatientsAssistantCabinet from "./AllPatinets_AssistantCabinet";
import AllCabinetSurveysHistory from "./AllCabinetSurveysHistory";
import OrganizationCabinetSurveyHistory from "./OrganizationCabinetSurveyHistory";
import AllCarSurveysHistory from "../../SystemManager/Calendar/CarSurveyHistory/AllCarSurveysHistory";
import OrganizationCarSurveysHistory from "../../SystemManager/Calendar/CarSurveyHistory/OrganizationCarSurveysHistory";
import {PatientQrResultSwitcher} from "../../General/QrResult/QrResult";
import OrgSearch from "../../General/OrgSearch";
import {PatientQrResultSwitcher2} from "../../General/QrResult2/QrResult2";

function AssistantCabinetRoutes() {
    const {REACT_APP_URL_PREFIX} = process.env

    return (
        <Switch>
            <Route path={REACT_APP_URL_PREFIX + '/orgSearch' } exact> <OrgSearch /></Route>

            <Route path={REACT_APP_URL_PREFIX + '/patients/allPatients'} exact><AllPatientsAssistantCabinet/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys'} exact><AllCabinetSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/cabinetSurveys/:orgId/:orgName'}
                   exact><OrganizationCabinetSurveyHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys'} exact><AllCarSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/calendar/carSurveys/:orgId/:orgName'}
                   exact><OrganizationCarSurveysHistory/></Route>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'} exact> <PatientQrResultSwitcher2 /> </Route>

            <Redirect to={REACT_APP_URL_PREFIX + '/patients/allPatients'}/>

        </Switch>
    );
}

export default AssistantCabinetRoutes;